import {
    Component,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter,
    Input,
    HostListener,
    ViewChildren,
    QueryList,
    ElementRef,
    ViewChild
} from '@angular/core';
import {ICsGridApi} from "@app/shared/cs-ag-grid-js/cs-ag-grid-js.interface";
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
    selector: 'cs-ag-grid-group-renderer',
    template: `
        <div class="grouping-wrapper">
            <span class="divider"></span>
            <span class="grouping-hint" *ngIf="groups.length">Group by:</span>
            <div class="drop-target"
                 [class.drag-over]="isDragOver"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave()"
                 (dragenter)="onDragEnter()"
                 (drop)="onDrop($event)">
        <span *ngIf="groups.length === 0 && placeholderIndex == null" class="group-empty-state">
            <span class="hint">Drop column header here to group the list</span>
        </span>
                <div #groupFlexWrapper class="group-flex-wrapper" *ngIf="groups.length > 0 || placeholderIndex === 0"
                     [ngStyle]="groupElementMaxWidth ? { 'max-width': groupElementMaxWidth + 'px' } : {}">
                    <ng-container *ngIf="groups.length > 0; else noGroups">
                        <div cdkDropList
                             [cdkDropListData]="visibleGroups"
                             (cdkDropListDropped)="onPillDrop($event)"
                             cdkDropListOrientation="horizontal"
                             class="group-pills-droplist">
                            <ng-container *ngFor="let group of visibleGroups; let i = index">
                                <div #placeHolder
                                     class="group-placeholder"
                                     *ngIf="placeholderIndex === i"
                                     (dragover)="onDragOver($event)"
                                ></div>
                                <div
                                    #groupLabel
                                    cdkDrag
                                    class="group-label"
                                    (dragover)="onDragOver($event)">
                                    {{ group.headerName }}
                                    <i class="fa fa-times" (click)="removeGroup(i)" style="cursor: pointer; margin-left: 6px;"></i>
                                </div>
                            </ng-container>
                        </div>
                        <div [class.group-placeholder]="isDragOver"
                             (dragover)="onDragOver($event)"
                             *ngIf="placeholderIndex === visibleGroups.length"
                        ></div>
                        <div #dropDownElement class="pos-rlt fx-layout-row fx-align--x-center group-dropDown" dropdown *ngIf="dropdownGroups.length > 0">
                            <button dropdownToggle type="button" class="btn group-label group-dropdown-btn">
                                <span>+{{ dropdownGroups.length }}</span>
                                <i class="fa-solid fa-angle-down"></i>
                            </button>
                            <div *dropdownMenu class="dropdown-menu more-group">
                                <span class="cs-caret cs-border-top cs-border-left"></span>
                                <div class="dropdown-groups-container">
                                <span *ngFor="let group of dropdownGroups; let i = index"
                                      class="group-label dropdown-group-item">
                                    <span class="group-text">{{ group.headerName }}</span>
                                    <i class="fa fa-times"
                                       (click)="removeDropdownGroup(i)"
                                       style="cursor: pointer; margin-left: 6px;"></i>
                                </span>
                                </div>
                            </div>
                        </div>
                        <div
                            style="flex: 1"
                            (dragover)="onDragOver($event)"
                            *ngIf="placeholderIndex === visibleGroups.length"
                        ></div>
                    </ng-container>
                    <ng-template #noGroups>
                        <div style="display: flex" *ngIf="placeholderIndex === 0">
                            <span class="grouping-hint" style="margin-right: 2px;">Group by:</span>
                            <span class="margin-x-2" [class.group-placeholder]="isDragOver"></span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .more-group {
            padding: 8px;
            margin-top: 16px;
        }
        .cs-caret {
            height: 1rem;
            width: 1rem;
            background: white;
            position: absolute;
            inset: -0.5rem 1rem auto auto;
            transform: rotate(45deg);
            border: 0.0625rem solid #E1E1E1;
            border-bottom-width: 0;
            border-right-width: 0;
            z-index: -1;
        }
        .group-dropdown-btn{
            color:#3883C1;
            gap: 6px;
            height: 26px !important;
            font-weight: 700;
        }
        .grouping-wrapper {
            display: flex;
            gap: 8px;
            align-items: center;
        }
        .divider:before {
            border-left: 2px solid #ccc;
            font-size: 16px;
            line-height: 20px;
            content: " ";
        }
        .group-empty-state {
            font-size: 14px;
            color: #999;
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 3px 0;
        }
        .drop-target {
            display: flex;
            align-items: center;
            gap: 8px;
            border-radius: 2px;
            padding: 0 2px;
            border: 1px dashed transparent;
            /*transition: border-color 0.2s ease;*/
            flex-basis: 100%;
        }
        .drop-target.drag-over {
            border-color: #9ED1F3;
            background-color: #E7F0F8;
        }
        .grouping-hint{
            font-weight: 700;
            font-size: 14px;
            line-height: 26px;
            color: #8E8E8E;
            white-space: nowrap;
        }
        .group-flex-wrapper {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: nowrap;
            width: 100%;
            white-space: nowrap;
        }
        .group-pills-droplist {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: nowrap;
            min-width: 0;
        }
        .group-pills-droplist.cdk-drag-dragging .cdk-drag-placeholder {
            opacity: 0;
        }
        .group-pills-droplist .cdk-drag-placeholder {
            width: 100px;
            height: 22px;
            background-color: #DDE6EB;
            border-radius: 2px;
        }
        .group-label {
            display: flex;
            align-items: center;
            padding: 4px 8px;
            border-radius: 2px;
            background: #FAFAFA;
            border: 1px solid #E1E1E1;
            font-size: 13px;
            height: 16px;
        }
        .group-placeholder {
            display:none;
            width: 200px;
            height: 30px;
            background-color: #DDE6EB;
            border-radius: 2px;
            margin: auto 0;
        }
        .margin-x-2{
            margin: 2px 0;
        }
        .hint {
            white-space: nowrap;
        }

        .dropdown-groups-container {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            width: 100%;
        }

        .dropdown-group-item {
            min-width: 0; /* Allows text to shrink */
            box-sizing: border-box;
            height:auto !important;
        }

        .group-text {
            word-wrap: break-word;
            overflow-wrap: break-word;
            hyphens: auto;
            line-height: 1.2;
            display: block;
            overflow: hidden;
        }

        .more-group {
            padding: 8px;
            margin-top: 16px;
            min-width: 240px; /* Ensure minimum width for 2-column layout */
            max-width: 300px; /* Prevent it from becoming too wide */
        }
        .group-label, .group-placeholder {
            flex-shrink: 0;          /* prevent shrinking on overflow */
        }
    `]
})
export class CsAgGridGroupRendererComponent implements OnInit, OnDestroy {
    @ViewChildren('groupLabel') groupLabelEls!: QueryList<ElementRef>;
    @ViewChildren('groupFlexWrapper') groupFlexWrapperEl!: QueryList<ElementRef>;
    @ViewChildren('placeHolder') placeHolderEL!: ElementRef;
    @ViewChild('dropDownElement') dropDownElementRef!: ElementRef;

    groups: any[] = [];
    isDragOver: boolean = false;
    @Output() groupsChanged = new EventEmitter<any[]>();
    @Output() groupsAdded = new EventEmitter<number>();
    @Input() gridInstance: ICsGridApi;
    gridColumnApi: any;
    dragCounter = 0;
    placeholderIndex: number | null = null;
    allowFromGlobal = false;
    sliceIndex;
    removePlaceHolderIndex = false;
    placeholderCount = 0;
    groupElementMaxWidth : number;
    private resizeDebounceTimer: ReturnType<typeof setTimeout> | null = null;
    private lastDragOverIndex: number | null = null;
    private dragOverThrottleTimer: ReturnType<typeof setTimeout> | null = null;
    private pendingDragEvent: DragEvent | null = null;

    constructor() {}
    ngOnInit(): void {
        this.gridColumnApi = this.gridInstance.gridApi;
    }

    @HostListener('window:resize')
    onWindowResize(): void {
        if (this.groups.length === 0) return;
        if (this.resizeDebounceTimer) clearTimeout(this.resizeDebounceTimer);
        this.resizeDebounceTimer = setTimeout(() => {
            this.resizeDebounceTimer = null;
            const wrapperEl = this.groupFlexWrapperEl && this.groupFlexWrapperEl.first && this.groupFlexWrapperEl.first.nativeElement;
            if (wrapperEl) {
                const width = wrapperEl.getBoundingClientRect().width;
                this.groupElementMaxWidth = width;
                this.calculateOccupiedWidth(width, '');
            }
        }, 150);
    }

    ngOnDestroy(): void {
        if (this.resizeDebounceTimer) {
            clearTimeout(this.resizeDebounceTimer);
            this.resizeDebounceTimer = null;
        }
        this.clearDragOverThrottle();
    }

    onDragEnter(): void {
        this.dragCounter++;
        this.isDragOver = true;
        if(this.groups.length && !this.dropdownGroups.length) {
            const draggedEl = document.getElementById('gridDraggedElement');
            const placeholder = draggedEl ? draggedEl.innerText : '';
            const wrapperElement = this.groupFlexWrapperEl.first.nativeElement; // Access the first element in the QueryList

            if (wrapperElement) {
                this.groupElementMaxWidth = this.groupElementMaxWidth ? this.groupElementMaxWidth : wrapperElement.getBoundingClientRect().width;
                this.calculateOccupiedWidth(this.groupElementMaxWidth, placeholder);
            }
            this.allowFromGlobal = true;
        }
    }

    onDragLeave(): void {
        this.dragCounter--;
        this.isDragOver = false;
        if (this.dragCounter === 0) {
            this.lastDragOverIndex = null;
            this.clearDragOverThrottle();
        }
    }

    // This method now correctly handles drag over the dropdown button.
    onDragOver(event: DragEvent): void {
        this.isDragOver = true;
        event.preventDefault();
        if (!this.groups.length) {
            if (this.placeholderIndex !== 0) {
                this.placeholderIndex = 0;
            }
            return;
        }

        this.pendingDragEvent = event;
        if (this.dragOverThrottleTimer === null) {
            this.applyDragOverPosition(event);
            this.dragOverThrottleTimer = setTimeout(() => {
                this.dragOverThrottleTimer = null;
                const e = this.pendingDragEvent;
                this.pendingDragEvent = null;
                if (e && this.groups.length) {
                    this.applyDragOverPosition(e);
                }
            }, 32);
        }
    }

    private applyDragOverPosition(event: DragEvent): void {
        const groupEls = this.groupLabelEls.toArray();
        let index = this.groups.length;
        let found = false;

        if (groupEls.length === 0) {
            index = this.sliceIndex ? this.visibleGroups.length : this.groups.length;
        } else {
            groupEls.forEach((elRef, i) => {
                if (found) return;
                const rect = elRef.nativeElement.getBoundingClientRect();
                if (event.clientX < rect.left + rect.width / 2) {
                    index = i;
                    found = true;
                }
            });
        }

        if (this.lastDragOverIndex === index) {
            return;
        }
        this.lastDragOverIndex = index;
        this.placeholderIndex = index;

        // When over the right (past all visible pills): show placeholder at end of visible row only.
        // Do NOT change sliceIndex/placeholderCount during drag - that resizes the drop target and
        // causes dragleave/dragenter flicker ("applied, remove, applied, remove").
        if (this.placeholderIndex === this.groups.length && this.sliceIndex) {
            this.placeholderIndex = this.visibleGroups.length;
        }
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        this.isDragOver = false;
        if (this.dragOverThrottleTimer !== null) {
            clearTimeout(this.dragOverThrottleTimer);
            this.dragOverThrottleTimer = null;
            this.pendingDragEvent = null;
            if (this.groups.length) {
                this.lastDragOverIndex = null;
                this.applyDragOverPosition(event);
            }
        }
        this.lastDragOverIndex = null;
        const raw = event.dataTransfer.getData('application/vnd.aggrid.coldef+json');

        if (!raw) return;
        let addedGroup = false;
        try {
            const colDef = JSON.parse(raw);
            if (!colDef.field) return;

            const isAlreadyGrouped = this.groups.some(g => g.field === colDef.field);
            if (isAlreadyGrouped) return;

            const insertIndex = this.placeholderIndex !== -1 ? this.placeholderIndex : this.groups.length;

            this.groups.splice(insertIndex, 0, colDef); // insert at placeholderIndex
            addedGroup = true;
            // Emit event when groups are added (length > 0)
            if (this.groups.length > 0) {
                this.groupsAdded.emit(this.groups.length);
            }
            this.groupsChanged.emit(this.groups);
            this.gridColumnApi.setRowGroupColumns(this.groups.map(col => col.field));
            this.gridInstance.refreshGridData();
        } catch (err) {
            console.error('Drop parsing failed', err);
        }
        this.placeholderIndex = null;
        if(this.removePlaceHolderIndex){
            this.sliceIndex++;
            this.removePlaceHolderIndex = false;
        }
        this.allowFromGlobal = false;

        if(this.placeholderCount) {
            this.sliceIndex += this.placeholderCount;
            this.placeholderCount = 0;
        }
        if (addedGroup) {
            this.recalculateOccupiedWidthAfterViewUpdate();
        }
    }

    removeGroup(index: number): void {
        this.groups.splice(index, 1);
        this.groupsChanged.emit(this.groups); // emit after remove

        // Emit event when groups are removed (count becomes 0 or still > 0)
        this.groupsAdded.emit(this.groups.length);

        // Update ag-Grid with the new list of field names
        const groupFields = this.groups.map(col => col.field);
        this.gridColumnApi.setRowGroupColumns(groupFields);
        this.gridInstance.refreshGridData();
        this.gridInstance.refreshHeaders();
        this.recalculateOccupiedWidthAfterViewUpdate();
    }

    onPillDrop(event: CdkDragDrop<any[]>): void {
        if (event.previousIndex === event.currentIndex) return;
        moveItemInArray(this.groups, event.previousIndex, event.currentIndex);
        this.groupsChanged.emit(this.groups);
        this.gridColumnApi.setRowGroupColumns(this.groups.map(col => col.field));
        this.gridInstance.refreshGridData();
        this.gridInstance.refreshHeaders();
        this.recalculateOccupiedWidthAfterViewUpdate();
    }
    private clearDragOverThrottle(): void {
        if (this.dragOverThrottleTimer !== null) {
            clearTimeout(this.dragOverThrottleTimer);
            this.dragOverThrottleTimer = null;
        }
        this.pendingDragEvent = null;
        this.lastDragOverIndex = null;
    }

    @HostListener('document:dragend', ['$event'])
    onGlobalDragEnd(event: DragEvent) {
        this.clearDragOverThrottle();
        if (this.groups.length && this.allowFromGlobal) {
            const wrapperElement = this.groupFlexWrapperEl.first.nativeElement; // Access the first element in the QueryList
            if (wrapperElement) {
                const width = wrapperElement.getBoundingClientRect().width;
                this.calculateOccupiedWidth(width, '');
            }
            this.allowFromGlobal = false;
        }
        this.dragCounter = 0;
        this.isDragOver = false;
        this.placeholderIndex = null;
        if (this.placeholderCount) {
            this.sliceIndex += this.placeholderCount;
            this.placeholderCount = 0;
        }
        // Recalc again after a short delay so header/grid have finished updating and "+N" count shows
        if (this.groups.length > 0) {
            setTimeout(() => this.recalculateOccupiedWidthAfterViewUpdate(), 80);
        }
    }

    get visibleGroups(): any[] {
        return this.groups.slice(0, this.sliceIndex ? this.sliceIndex : this.groups.length);
    }

    get dropdownGroups(): any[] {
        return this.sliceIndex ? this.groups.slice(this.sliceIndex) : [];
    }

    /** Recalculate visible/dropdown split after the view has updated (e.g. after add/reorder/remove). */
    private recalculateOccupiedWidthAfterViewUpdate(): void {
        if (this.groups.length === 0) return;
        // Run after two ticks so Angular and the grid have rendered the new/removed pills
        setTimeout(() => {
            setTimeout(() => {
                const wrapperEl = this.groupFlexWrapperEl && this.groupFlexWrapperEl.first && this.groupFlexWrapperEl.first.nativeElement;
                if (wrapperEl) {
                    const width = wrapperEl.getBoundingClientRect().width;
                    this.groupElementMaxWidth = width;
                    this.calculateOccupiedWidth(width, '');
                }
            }, 0);
        }, 0);
    }

    // Add this method to handle dropdown group removal:
    removeDropdownGroup(dropdownIndex: number): void {
        const actualIndex = this.sliceIndex + dropdownIndex;
        this.removeGroup(actualIndex);
    }

    calculateOccupiedWidth(overAllWidth, placeholder): void {
        let totalWidth = 0;
        let updatedIndex = undefined;
        const groupFlexWrapperGap = 8; // From your CSS: gap: 12px;;
        const placeholderWidth = placeholder ? Math.max(this.calculateWidthOfGroupElements(placeholder), 100) : 100; // From your CSS: width: 100px;
        let dropdownWidth = 0;
        if (this.dropdownGroups.length > 0 && this.dropDownElementRef && this.dropDownElementRef.nativeElement) {
            dropdownWidth = this.dropDownElementRef.nativeElement.getBoundingClientRect().width;
        } else if (this.dropDownElementRef && this.dropDownElementRef.nativeElement) {
            dropdownWidth = 50; // reserve space for "+N" when dropdown will appear
        }

        const availableWidth = overAllWidth - dropdownWidth - groupFlexWrapperGap;
        const WIDTH_TOLERANCE_PX = 2;
        let groupLabelElements: any = this.groupLabelEls.toArray();
        const insertIndex = this.placeholderIndex != null ? this.placeholderIndex : this.groups.length;
        groupLabelElements.splice(insertIndex, 0, { width: placeholderWidth, isPlaceHolder: true });

        groupLabelElements.forEach((elRef, index) => {
            const labelWidth = elRef.hasOwnProperty('isPlaceHolder')? elRef.width : elRef.nativeElement.getBoundingClientRect().width;
            totalWidth += labelWidth;

            if (index < groupLabelElements.length - 1) {
                totalWidth += groupFlexWrapperGap;
            }

            if ((availableWidth + WIDTH_TOLERANCE_PX) < totalWidth && updatedIndex === undefined) {
                updatedIndex = index;
            }
        });

        this.removePlaceHolderIndex = !!(this.placeHolderEL && updatedIndex);
        this.sliceIndex =  updatedIndex;
    }

    calculateWidthOfGroupElements (content: string = '') {
        const dragPreviewEl = document.createElement('div');
        dragPreviewEl.innerText = content;
        Object.assign(dragPreviewEl.style,{
            padding: '4px 8px',
            background: '#e1fcda',
            border: '1px solid #c3e6cb',
            borderRadius: '2px',
            fontSize: '13px',
            fontFamily: 'inherit',
            color: '#2e7d32',
            position: 'absolute',
            top: '-1000px'
        });

        document.body.appendChild(dragPreviewEl);
        const width = dragPreviewEl.offsetWidth+17;
        document.body.removeChild(dragPreviewEl);
        return width;
    }
}
